import React from 'react';
import perfil from '../../assets/images/website/perfil.png';

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative">
      <img
        src={perfil}
        alt="imagem de perfil"
        className="w-[300px] h-[400px] lgl:w-[500px] lgl:h-[680px] z-10"
      />
    </div>
  );
};

export default RightBanner;
